import React from 'react';
import { compose } from 'ramda';
import { Map, List } from 'immutable';
import styleFile from './header.js';
import { RichText } from '@synergycms_core/components/generic';
import { concatChildAgeText } from '../../../utils';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import TooltipWrapper from '@synergycms_core/components/generic/TooltipWrapper';
import { Image } from '@synergycms_core/components/generic';
import { iconsByTheme } from '@synergycms_core/components/functional/Engine/engineUtils';

const RoomInfo = compose(withThemeJSS({ styleFile, displayName: 'Header' }))((props) => {
  const { theme, params, availInfoTheme, modalBreak } = props;
  const { classes } = theme.styles;
  const cx = props.theme.bind();

  const occups = params.get('occups').reduce((occupCounter, occup) => {
    return occupCounter
    .set('adults', occupCounter.get('adults') + occup.get('adults', 0))
    .set('childs', occupCounter.get('childs') + occup.get('childs', 0))
    .set('childsAge', occupCounter.get('childsAge').concat(occup.get('childsAge',List())));
  }, Map({ adults: 0, childs: 0, childsAge:List() }));

  const childsAge = (props.enableAge && concatChildAgeText({childsInfo :occups.get("childsAge", List()).map(c => c?.get("age"))})) || "";

  const occupsSize = params.get('occups').size;
  const occupsChilds = occups.get('childs');

  const renderMinimalView = () => {
    if (!modalBreak) {
      return occupsChilds ? (
        <div className={[classes.roomContainer, classes.minimalRoomContainer].join(' ')}>
          <div className={[classes.roomQuantityContainer, classes.minimalRoomOccupContainer].join(' ')}>
            <RichText
              icon={{ unicodeContent: iconsByTheme('boxOccups',theme.theme), innerStyle: [cx({size22:!modalBreak, size20:modalBreak})] }}
              innerStyle={classes.headerTitle}
            />
            <RichText innerStyle={[classes.roomQuantity, classes.engineClosedTitles]} text={occups.get('adults') + ' · ' + occups.get('childs')} />
          </div>
          <div className={[classes.roomQuantityContainer, classes.minimalRoomQuantityContainer].join(' ')}>
            <RichText
              translate={true}
              ucFirst={true}
              icon={{ unicodeContent: 'e14d', innerStyle: ['size27'] }}
              quantity={occupsSize}
              plural={true}
              innerStyle={classes.headerTitle}
            />
            <RichText text={occupsSize} innerStyle={[classes.roomQuantity, classes.engineClosedTitles]} />
          </div>
        </div>
      ) : (
        <div className={[classes.roomContainer, classes.minimalRoomContainer].join(' ')}>
          <div className={[classes.roomQuantityContainer, classes.minimalRoomOccupContainer].join(' ')}>
            <RichText
              icon={{ unicodeContent: iconsByTheme('boxOccups',theme.theme), innerStyle: [cx({size22:!modalBreak, size20:modalBreak})] }}
              innerStyle={classes.headerTitle}
            />
            <RichText innerStyle={[classes.roomQuantity, classes.engineClosedTitles]} text={occups.get('adults') + occups.get('childs')} />
          </div>
          <div className={[classes.roomQuantityContainer, classes.minimalRoomQuantityContainer].join(' ')}>
            <RichText
              translate={true}
              ucFirst={true}
              icon={{ unicodeContent: 'e14d', innerStyle: ['size27'] }}
              quantity={occupsSize}
              plural={true}
              innerStyle={classes.headerTitle}
            />
            <RichText text={occupsSize} innerStyle={[classes.roomQuantity, classes.engineClosedTitles]} />
          </div>
        </div>
      );
    } else {
      return (
        <div className={[classes.roomContainer, classes.minimalRoomContainer].join(' ')}>
          <RichText
            icon={{ unicodeContent: iconsByTheme('boxOccups',theme.theme), innerStyle: ['size20'] }}
            innerStyle={[classes.headerTitle, classes.calendarIcon]}
          />
          {occupsSize > 1 ? (
            <>
              <RichText
                innerStyle={[classes.roomQuantity, classes.engineClosedTitles]}
                translate={true}
                text={occups.get('adults') + ' · ' + occups.get('childs')}
              />
              <div className={[classes.roomQuantityContainer, classes.minimalRoomQuantityContainer].join(' ')}>
                <RichText text={occupsSize} innerStyle={classes.roomQuantity} />
                <RichText
                  translate={true}
                  ucFirst={true}
                  icon={modalBreak && { unicodeContent: 'e14d', innerStyle: ['size20'] }}
                  quantity={occupsSize}
                  plural={true}
                  innerStyle={classes.headerTitle}
                />
              </div>
            </>
          ) : occupsChilds ? (
            <>
              <RichText
                innerStyle={[classes.roomQuantity, classes.engineClosedTitles]}
                translate={true}
                text={occups.get('adults') + ' · ' + occups.get('childs')}
              />
              <div className={[classes.roomQuantityContainer, classes.minimalRoomQuantityContainer].join(' ')}>
                <RichText text={occupsSize} innerStyle={classes.roomQuantity} />
                <RichText
                  translate={true}
                  ucFirst={true}
                  icon={modalBreak && { unicodeContent: 'e14d', innerStyle: ['size20'] }}
                  quantity={occupsSize}
                  plural={true}
                  innerStyle={classes.headerTitle}
                />
              </div>
            </>
          ) : (
            <>
              <RichText
                innerStyle={[classes.roomQuantity, classes.engineClosedTitles]}
                text={occups.get('adults') + occups.get('childs')}
              />
              <div className={[classes.roomQuantityContainer, classes.minimalRoomQuantityContainer].join(' ')}>
                <RichText text={occupsSize} innerStyle={classes.roomQuantity} />
                <RichText
                  translate={true}
                  ucFirst={true}
                  icon={modalBreak && { unicodeContent: 'e14d', innerStyle: ['size20'] }}
                  quantity={occupsSize}
                  plural={true}
                  innerStyle={classes.headerTitle}
                />
              </div>
            </>
          )}
        </div>
      );
    }
  };

  const renderCompleteView = () => {
    return (
      <div className={classes.roomContainer}>
        <RichText
          text={theme.width > 900 && '_%Habitaciones%_'}
          icon={{ unicodeContent: iconsByTheme('boxOccups',theme.theme), innerStyle: [ cx({size22:theme.width > 900, size16:theme.width < 900}), classes.roomIcon] }}
          translate={true}
          ucFirst={true}
          innerStyle={classes.supTitle}
        />
        <RichText
          innerStyle={classes.roomQuantity}
          text={props.theme.width > 900 ? occups.get('adults') : 'x ' + (occups.get('adults') + occups.get('childs'))}
        />
        {props.theme.width > 900 && (
          <RichText
            translate={true}
            ucFirst={true}
            quantity={occups.get('adults')}
            text={'_%adulto%_'}
            innerStyle={classes.headerTitle}
          />
        )}
        {props.theme.width > 900 && occups.get('childs') > 0 && (
          <React.Fragment>
            <RichText
              innerStyle={classes.roomQuantity}
              text={occups.get('childs')}
            />
            <RichText
              translate={true}
              ucFirst={true}
              quantity={occups.get('childs')}
              text={'_%niño%_'}
              innerStyle={classes.headerTitle}
            />
          </React.Fragment>
        )}{' '}
        {props.theme.width > 900 && occups.get('childs') > 0 && childsAge && (
        <React.Fragment>
          <TooltipWrapper
            popover={<span>{childsAge}</span>}
            bottomLimit={100}
            popoverStyle={classes.yearsTooltip}
            typeTooltip={'occupInfoTooltip'}
            pointerStyle={classes.tooltipPointerStyle}
            posX={'middle'}
            posY={'bottom'}>
            <Image unicodeContent="e143" innerStyle={['gold']}/>
          </TooltipWrapper>{'  '}
        </React.Fragment>
        )}
        <div className={classes.roomQuantityContainer}>
          <RichText text={props.theme.width > 900 ? '- ' + params.get('occups').size : 'x ' + params.get('occups').size} innerStyle={classes.roomQuantity} />
          <RichText
            translate={true}
            ucFirst={true}
            icon={props.theme.width < 901 && { unicodeContent: 'e14d', innerStyle: ['size16'] }}
            quantity={params.get('occups').size}
            plural={true}
            text={props.theme.width > 900 && '_%Hab%_'}
            innerStyle={classes.headerTitle}
          />
        </div>
      </div>
    );
  };

if (availInfoTheme === 'minimal') {
    return renderMinimalView();
  } else {
    return renderCompleteView();
  }
});

export default RoomInfo;
